import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { Footnote } from '@oneaudi/footnote-service/dist/cjs/types/footnotes-response.type';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useAppServices } from '~/app/contexts/app-context';
import { useI18n } from '~/app/i18n/i18n';
import { useFootnotes } from '~/components/footnotes';
import { CAE_CONFIGUREDCAR_REMARK, CAE_REMARK } from '~/components/footnotes/constants';
import { state } from '~/storage';

const ConsumptionFootnote = () => {
	const [consumptionDisclaimers] = useAtom(state.consumptionDisclaimersAtom);
	const footnoteContent = PrepareConsumptionFootnote(consumptionDisclaimers);
	const { i18n } = useI18n();

	const {
		featureServices: { footnoteService },
	} = useAppServices();

	useEffect(() => {
		if (footnoteContent) {
			const footnote = [{ Key: CAE_REMARK, Text: footnoteContent ?? '' } as Footnote];
			footnoteService?.replaceFootNotes(footnote);
		}
		return () => {
			footnoteService?.replaceFootNotes([
				{
					Key: CAE_REMARK,
					Text: '',
				},
			]);
		};
	}, [footnoteContent]);

	return <FootnoteReferenceV2 footnoteId={CAE_REMARK} footnoteAriaLabel={i18n('ngc.a11y.footnotes.cae')} />;
};

function PrepareConsumptionFootnote(disclaimers: string[]): string {
	if (!disclaimers || disclaimers.length < 1) return '';
	const regEx = new RegExp(/\{\{[^()]*\}\}/gm);
	const disclaimerText = disclaimers.reduce((acc, curr) => {
		return acc.replace(regEx, '') + ' | ' + curr.replace(regEx, '');
	});
	return disclaimerText;
}

export function RegisterOrUpdateConsumptionFootnoteForDialog(
	overrideDisclaimer?: string[],
	consumptionDisclaimerIdentifier?: string,
): void {
	const { addFootnote } = useFootnotes();
	const [consumptionDisclaimers] = useAtom(state.consumptionDisclaimersConfiguredCarAtom);
	const disclaimer = PrepareConsumptionFootnote(overrideDisclaimer || consumptionDisclaimers);
	const disclaimerIdentifier = consumptionDisclaimerIdentifier || CAE_CONFIGUREDCAR_REMARK;

	addFootnote(disclaimerIdentifier, disclaimer);
}

export default ConsumptionFootnote;
